'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.setMinMaxTimestamps = undefined;

var _curry = require('transmute/curry');

var _curry2 = _interopRequireDefault(_curry);

var _pipe = require('transmute/pipe');

var _pipe2 = _interopRequireDefault(_pipe);

var _threadHistoryInvariant = require('../../invariants/threadHistoryInvariant');

var _getMaximumEndTimestamp = require('./getMaximumEndTimestamp');

var _getMinimumStartTimestamp = require('./getMinimumStartTimestamp');

var _setters = require('./setters');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var setMinMaxTimestamps = exports.setMinMaxTimestamps = (0, _curry2.default)(function (oldThreadHistory, newThreadHistory) {
  (0, _threadHistoryInvariant.threadHistoryInvariant)(newThreadHistory);
  (0, _threadHistoryInvariant.threadHistoryInvariant)(oldThreadHistory);
  return (0, _pipe2.default)((0, _setters.setStartTimestamp)((0, _getMinimumStartTimestamp.getMinimumStartTimestamp)(oldThreadHistory, newThreadHistory)), (0, _setters.setEndTimestamp)((0, _getMaximumEndTimestamp.getMaximumEndTimestamp)(oldThreadHistory, newThreadHistory)))(newThreadHistory);
});